async function initStringServiceCharge() {
  const shopifyStorefrontAccessToken = '72fa3bbb17d8c029093b15c36457d990';
  const productIdEl = document.querySelector('[data-product-id]');
  const productId = productIdEl ? productIdEl.getAttribute('data-product-id') : null;
  const stringServiceSelector = document.querySelector('[data-string-dropdown-select]');
  const stringOptions = stringServiceSelector && stringServiceSelector.getAttribute('data-string-options')
    ? JSON.parse(stringServiceSelector.getAttribute('data-string-options'))
    : null;
  if (!stringServiceSelector || !stringOptions) return;
  const frontStringServiceElement = document.querySelector('[data-string-front-data-service]');
  const stringOptionSection = document.querySelector('[data-string-option-section]');
  const stringOptionSelects = document.querySelectorAll('[data-string-option-dropdown-select]');
  const buyCartBtn = document.querySelector('[data-buy-cart-btn]');
  const buyCartBtnDisabled = document.querySelector('[data-buy-cart-btn--disabled]');
  const buyNowBtn = document.querySelector('[data-buy-now-cart]');
  const buyNowEmptyBtn = document.querySelector('[data-buy-now-empty-btn]');
  const buyNowEmptyBtnDisabled = document.querySelector('[data-buy-now-empty-btn--disabled]');
  const buyNowBtnDisabled = document.querySelector('[data-buy-now-cart--disabled]');
  const mobileStickyAtcBtn = document.querySelector('[data-mobile-atc]');
  const stringDataInput = document.querySelector('[data-string-data-input]');
  const serviceChargePriceInput = document.querySelector('[data-string-service-charge-price]');
  const stringOptionLabels = ['스트링 모델', '텐션 세로(메인)', '텐션 가로(크로스)', '스텐실', '오버그립(사은품)'];
  const isCustomer = window.isCustomer;

  /** Truncate to 40 bytes (UTF-8) and append "..." when longer. Used for string dropdown display text in sticky popup. */
  function truncateTo40Bytes(str) {
    if (str == null || typeof str !== 'string') return str;
    const encoder = new TextEncoder();
    const bytes = encoder.encode(str);
    if (bytes.length <= 40) return str;
    const suffix = '...';
    const suffixLen = encoder.encode(suffix).length;
    let n = 0;
    for (let i = 0; i < str.length; i++) {
      if (encoder.encode(str.slice(0, i + 1)).length > 40 - suffixLen) break;
      n = i + 1;
    }
    return (n ? str.slice(0, n) : '') + suffix;
  }

  // _string_data (for wilson)
  // tension_mains: 텐션 세로(메인)
  // tension_crosses: 텐션 가로(크로스)

  const stringModelStencilRules = {
    "SV 럭실론 4G 125 - 골드": {
      availableStencilOptions: ["옵션을 선택해주세요", `레드 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    },
    "SV 럭실론 4G 125 - 블랙": {
      availableStencilOptions: ["스텐실 작업 불가"],
      defaultStencil: "스텐실 작업 불가",
    },
    "SV 럭실론 4G 러프 125 - 골드": {
      availableStencilOptions: ["옵션을 선택해주세요", `레드 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    },
    "SV 럭실론 알루 파워 125 - 블랙": {
      availableStencilOptions: ["스텐실 작업 불가"],
      defaultStencil: "스텐실 작업 불가",
    },
    "SV 럭실론 알루 파워 125 - 실버": {
      availableStencilOptions: ["옵션을 선택해주세요", `레드 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    },
    "SV 럭실론 알루 파워 러프 125 - 실버": {
      availableStencilOptions: ["옵션을 선택해주세요", `레드 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    },
    "SV 럭실론 에코 스핀 125 - 블랙": {
      availableStencilOptions: ["스텐실 작업 불가"],
      defaultStencil: "스텐실 작업 불가",
    },
    "SV 럭실론 에코 파워 125 - 그린": {
      availableStencilOptions: ["옵션을 선택해주세요", `레드 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    },
    "SV 럭실론 엘리멘트 125 - 브론즈": {
      availableStencilOptions: ["옵션을 선택해주세요", `블랙 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    },
    "SV 럭실론 엘리멘트 소프트 127 - 레드": {
      availableStencilOptions: ["옵션을 선택해주세요", `블랙 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    },
    "SV 윌슨 리볼브 17 - 화이트": {
      availableStencilOptions: ["옵션을 선택해주세요", `레드 "W"`, "미선택"],
      defaultStencil: "옵션을 선택해주세요",
    }
  }

  /** Apply to all stencil menus in the page (PDP + sticky), like the working single-context version. */
  const showAllStencilOptions = (scopeEl) => {
    const root = scopeEl && scopeEl.querySelector ? scopeEl : document;
    const menus = root.querySelectorAll('[data-custom-string-option-dropdown-menu-value="스텐실"]');
    menus.forEach((stencilMenu) => {
      stencilMenu.querySelectorAll('[data-custom-string-option-dropdown-item]').forEach((item) => {
        item.style.display = 'block';
      });
    });
  };

  const hideAllStencilOptions = (scopeEl) => {
    const root = scopeEl && scopeEl.querySelector ? scopeEl : document;
    const menus = root.querySelectorAll('[data-custom-string-option-dropdown-menu-value="스텐실"]');
    menus.forEach((stencilMenu) => {
      stencilMenu.querySelectorAll('[data-custom-string-option-dropdown-item]').forEach((item) => {
        item.style.display = 'none';
      });
    });
  };

  const showStencilOption = (option, scopeEl) => {
    const root = scopeEl && scopeEl.querySelector ? scopeEl : document;
    const menus = root.querySelectorAll('[data-custom-string-option-dropdown-menu-value="스텐실"]');
    menus.forEach((stencilMenu) => {
      stencilMenu.querySelectorAll('[data-custom-string-option-dropdown-item]').forEach((item) => {
        const itemValue = item.getAttribute('data-custom-string-option-dropdown-item-value');
        if (itemValue === option) item.style.display = 'block';
      });
    });
  };

  /** Ensure native select has an option so .value = x sticks (e.g. "스텐실 작업 불가" may not come from API). */
  const ensureStencilOptionExists = (selectEl, value) => {
    if (!selectEl || !value) return;
    const hasOption = Array.from(selectEl.options).some((opt) => opt.value === value);
    if (!hasOption) {
      const opt = document.createElement('option');
      opt.value = value;
      opt.textContent = value;
      selectEl.appendChild(opt);
    }
  };

  /** Update visible .text .value for a select (pretty-select display). Used so stencil dropdown shows the set value. */
  const setStencilDisplayText = (selectEl, text) => {
    if (!selectEl) return;
    const valueEl = selectEl.nextElementSibling?.querySelector('.value') || selectEl.closest('.pretty-select')?.querySelector('.text .value');
    if (valueEl) valueEl.textContent = text || '';
  };

  /** Match working version: update all stencil selects and menus so value is set everywhere (PDP + sticky). */
  const updateStencilOptionByStringModel = (selectedStringModel, scopeEl) => {
    const root = scopeEl && scopeEl.querySelector ? scopeEl : document;
    const stencilSelects = root.querySelectorAll('[data-string-option-dropdown-select-value="스텐실"]');
    const stencilMenus = root.querySelectorAll('[data-custom-string-option-dropdown-menu-value="스텐실"]');
    const stringModelValue = selectedStringModel.split(' + ')[0];

    if (!stencilSelects.length || !stencilMenus.length) return;

    const rules = stringModelStencilRules[stringModelValue];

    if (!rules) {
      showAllStencilOptions(root);
      return;
    }

    hideAllStencilOptions(root);
    rules.availableStencilOptions.forEach((option) => showStencilOption(option, root));

    const frontStencilElements = document.querySelectorAll('[data-string-front-data-stencil]');

    if (rules.availableStencilOptions[0] === "스텐실 작업 불가") {
      const valueToSet = "스텐실 작업 불가";
      stencilSelects.forEach((stencilSelect) => {
        ensureStencilOptionExists(stencilSelect, valueToSet);
        stencilSelect.value = valueToSet;
        stencilSelect.disabled = true;
        setStencilDisplayText(stencilSelect, valueToSet);
        stencilSelect.dispatchEvent(new Event('change'));
      });
      selectedOptions.stencil_value = valueToSet;
      frontStencilElements.forEach((el) => { el.value = valueToSet; });
      const stickyAtcContainer = document.querySelector('[data-product-sticky-atc]');
      if (stickyAtcContainer && window.jQuery) {
        try {
          window.jQuery(window).trigger('cc-variant-updated');
        } catch (err) {
          // theme.js listener may expect variant/product; ignore when only stencil was updated
        }
      }
    } else if (rules.defaultStencil === "옵션을 선택해주세요") {
      const valueToSet = '옵션을 선택해주세요';
      selectedOptions.stencil_value = "";
      stencilSelects.forEach((stencilSelect) => {
        stencilSelect.value = valueToSet;
        stencilSelect.disabled = false;
        setStencilDisplayText(stencilSelect, valueToSet);
        stencilSelect.dispatchEvent(new Event('change'));
      });
      frontStencilElements.forEach((el) => { el.value = ""; });
    } else {
      stencilSelects.forEach((stencilSelect) => { stencilSelect.disabled = false; });
    }
  }

  let selectedOptions = {
    service_id: '',
    string_option: '',
    string_model: '',
    tension_mains: '',
    tension_crosses: '',
    stencil_value: '',
    overgrip_yn: '',
    service_charge: 'N',
  };

  /**
   * Validate _string_data before cart submission.
   * Returns true if data is valid or string service is not selected.
   */
  const validateStringData = () => {
    const currentOption = selectedOptions.string_option;
    if (!currentOption || currentOption === stringOptions[0] || currentOption === stringOptions[3]) {
      return true;
    }
    const requiredFields = ['string_option', 'string_model', 'tension_mains', 'tension_crosses', 'stencil_value', 'overgrip_yn'];
    return requiredFields.every(field => selectedOptions[field] !== '');
  };

  window.validateStringData = validateStringData;

  /** 현재 스트링 옵션 상태 기준으로 버튼 활성화 여부를 계산 */
  const getButtonEnabled = () => {
    const currentValue = stringServiceSelector.value;
    const isNoString = currentValue === stringOptions[3];
    const allFilled = Object.values(selectedOptions).every(v => v !== '');
    return currentValue !== stringOptions[0] && (isNoString || allFilled);
  };

  // syncStringDataToForm, resetSelectedOptions는 renderState()로 대체됨

  // initial value
  stringServiceSelector.setAttribute('data-string-dropdown-select-value', stringOptions[0]);

  /** Returns form inputs for the given scope (main PDP or sticky popup). Use when updating string data so sticky ATC sends correct values. */
  const getInputsForScope = (scopeEl) => {
    const stickyAtc = scopeEl && scopeEl.closest ? scopeEl.closest('[data-product-sticky-atc]') : null;
    if (stickyAtc) {
      const form = stickyAtc.querySelector('form');
      if (!form) return null;
      return {
        stringDataInput: form.querySelector('[data-string-data-input]'),
        serviceChargePriceInput: form.querySelector('[data-string-service-charge-price]'),
        frontStringServiceElement: form.querySelector('[data-string-front-data-service]'),
        frontStringModelElement: form.querySelector('[data-string-front-data-model]'),
        frontTensionMainsElement: form.querySelector('[data-string-front-data-mains]'),
        frontTensionCrossesElement: form.querySelector('[data-string-front-data-crosses]'),
        frontStencilElement: form.querySelector('[data-string-front-data-stencil]'),
        frontOvergripElement: form.querySelector('[data-string-front-data-overgrip]'),
        mainStringDropdown: stickyAtc.querySelector('[data-string-dropdown-select]')
      };
    }
    return {
      stringDataInput,
      serviceChargePriceInput,
      frontStringServiceElement,
      frontStringModelElement: document.querySelector('[data-string-front-data-model]'),
      frontTensionMainsElement: document.querySelector('[data-string-front-data-mains]'),
      frontTensionCrossesElement: document.querySelector('[data-string-front-data-crosses]'),
      frontStencilElement: document.querySelector('[data-string-front-data-stencil]'),
      frontOvergripElement: document.querySelector('[data-string-front-data-overgrip]'),
      mainStringDropdown: stringServiceSelector
    };
  };

  // ====================================================================
  // renderState() — 단일 진실의 원천: selectedOptions → 모든 UI 파생
  // ====================================================================

  let encryptedServiceChargePrice = '';

  const generateServiceId = () => Date.now().toString() + Math.random().toString(36).substring(2, 9);

  function getAllFormContexts() {
    const contexts = [];
    const pdpForm = stringDataInput?.closest('form');
    if (pdpForm) {
      const pdpRoot = pdpForm.closest('[data-section-id]') || pdpForm.parentElement;
      contexts.push({ root: pdpRoot, form: pdpForm, isSticky: false });
    }
    const stickyAtc = document.querySelector('[data-product-sticky-atc]');
    if (stickyAtc) {
      const stickyForm = stickyAtc.querySelector('form[data-sticky-atc-form]');
      if (stickyForm) {
        contexts.push({ root: stickyAtc, form: stickyForm, isSticky: true });
      }
    }
    return contexts;
  }

  function renderMainDropdown(ctx) {
    const dropdown = ctx.root.querySelector('[data-string-dropdown-select]');
    if (!dropdown) return;
    const value = selectedOptions.string_option || stringOptions[0];
    if (dropdown.value !== value) dropdown.value = value;
    dropdown.setAttribute('data-string-dropdown-select-value', value);
    const container = dropdown.closest('.dropdown-container');
    if (container) syncMainDropdownDisplayAndActive(container);
  }

  function renderOptionSection(ctx) {
    const section = ctx.root.querySelector('[data-string-option-section]');
    if (!section) return;
    const option = selectedOptions.string_option;
    const show = option && option !== stringOptions[0] && option !== stringOptions[3];
    section.style.display = show ? 'flex' : 'none';
  }

  function getStencilSelectValue() {
    const v = selectedOptions.stencil_value;
    if (!v) return '옵션을 선택해주세요';
    if (v === 'null') return '미선택';
    return v;
  }

  function getOvergripSelectValue() {
    const v = selectedOptions.overgrip_yn;
    if (v === 'Y') return '무료로 제공됩니다. (+ 0원)';
    if (v === 'N') return '미선택';
    return '옵션을 선택해주세요';
  }

  function renderSubOptions(ctx) {
    const option = selectedOptions.string_option;
    const isRecommend = option === stringOptions[2];
    const isCustom = option === stringOptions[1];

    const modelName = selectedOptions.string_model ? selectedOptions.string_model.split(' + ')[0] : '';
    const stencilRules = stringModelStencilRules[modelName];
    const isStencilForced = stencilRules && stencilRules.availableStencilOptions[0] === '스텐실 작업 불가';

    const subOptionsMap = [
      { label: '스트링 모델', value: selectedOptions.string_model || '옵션을 선택해주세요', disabled: isRecommend, isModel: true },
      { label: '텐션 세로(메인)', value: selectedOptions.tension_mains || '옵션을 선택해주세요', disabled: isRecommend },
      { label: '텐션 가로(크로스)', value: selectedOptions.tension_crosses || '옵션을 선택해주세요', disabled: isRecommend },
      { label: '스텐실', value: getStencilSelectValue(), disabled: isRecommend || isStencilForced },
      { label: '오버그립(사은품)', value: getOvergripSelectValue(), disabled: isRecommend || isCustom },
    ];

    subOptionsMap.forEach(({ label, value, disabled, isModel }) => {
      const select = ctx.root.querySelector(`[data-string-option-dropdown-select-value="${label}"]`);
      if (!select) return;

      // Ensure option exists for forced stencil values
      if (label === '스텐실') ensureStencilOptionExists(select, value);

      if (select.value !== value) select.value = value;
      select.disabled = disabled;

      // Pretty-select display
      if (isModel) {
        setStringModelColor(select, value);
      } else {
        updatePrettySelectDisplay(select, value);
      }

      // Pretty-select disabled class
      const prettySelect = select.closest('.pretty-select');
      if (prettySelect) {
        if (disabled) prettySelect.classList.add('is-disabled');
        else prettySelect.classList.remove('is-disabled');
      }

      // Custom dropdown selected state (sticky only)
      syncStringOptionDropdownSelected(select);
    });
  }

  function renderStencilRules(ctx) {
    const stringModel = selectedOptions.string_model;
    if (!stringModel) {
      showAllStencilOptions(ctx.root);
      return;
    }
    const modelName = stringModel.split(' + ')[0];
    const rules = stringModelStencilRules[modelName];
    if (!rules) {
      showAllStencilOptions(ctx.root);
      return;
    }
    hideAllStencilOptions(ctx.root);
    rules.availableStencilOptions.forEach(option => showStencilOption(option, ctx.root));
  }

  function renderHiddenInputs(ctx) {
    const option = selectedOptions.string_option;
    const isNoString = option === stringOptions[3];
    const isPlaceholder = !option || option === stringOptions[0];
    const hasData = !isNoString && !isPlaceholder;

    const dataInput = ctx.form.querySelector('[data-string-data-input]');
    if (dataInput) {
      if (hasData) {
        dataInput.disabled = false;
        dataInput.value = JSON.stringify(selectedOptions);
      } else {
        dataInput.disabled = isNoString;
        dataInput.value = '';
      }
    }

    const frontMap = [
      ['data-string-front-data-service', isNoString ? option : (hasData ? option : '')],
      ['data-string-front-data-model', hasData ? selectedOptions.string_model : ''],
      ['data-string-front-data-mains', hasData ? selectedOptions.tension_mains : ''],
      ['data-string-front-data-crosses', hasData ? selectedOptions.tension_crosses : ''],
      ['data-string-front-data-stencil', hasData ? (selectedOptions.stencil_value === 'null' ? '미선택' : selectedOptions.stencil_value) : ''],
      ['data-string-front-data-overgrip', hasData ? (selectedOptions.overgrip_yn === 'Y' ? '무료로 제공됩니다. (+ 0원)' : selectedOptions.overgrip_yn === 'N' ? '미선택' : '') : ''],
    ];

    frontMap.forEach(([attr, value]) => {
      const el = ctx.form.querySelector(`[${attr}]`);
      if (!el) return;
      el.value = value;
      el.disabled = isNoString && attr !== 'data-string-front-data-service';
    });

    const chargeInput = ctx.form.querySelector('[data-string-service-charge-price]');
    if (chargeInput) {
      chargeInput.value = hasData ? encryptedServiceChargePrice : '';
      chargeInput.disabled = !hasData;
    }
  }

  function renderButtons() {
    const option = selectedOptions.string_option;
    const isNoString = option === stringOptions[3];
    const isPlaceholder = !option || option === stringOptions[0];
    const allFilled = Object.values(selectedOptions).every(v => v !== '');
    const enabled = isNoString || (!isPlaceholder && allFilled);

    updateButtonStates(
      enabled ? {} : { cartEnabled: false, buyNowEnabled: false },
      { updatePdpButtons: true, updateStickyPopup: true }
    );
  }

  function renderState() {
    const contexts = getAllFormContexts();
    contexts.forEach(ctx => {
      renderMainDropdown(ctx);
      renderOptionSection(ctx);
      renderSubOptions(ctx);
      renderStencilRules(ctx);
      renderHiddenInputs(ctx);
    });
    renderButtons();
  }
  window.renderState = renderState;

  // ====================================================================

  const fetchGraphQL = async (query) => {
    return await fetch('/api/2025-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': shopifyStorefrontAccessToken,
      },
      body: JSON.stringify({ query })
    });
  };

  const productQuery = (productId) => {
    return `
      query {
        product(id: "${productId}") {
          id
          title
          variants(first: 10) {
            edges {
              node {
                id
                title
                price {
                  amount
                  currencyCode
                }
              }
            }
          }
        }
      }
    `;
  };

  // ✅ Query String Service Default Option Value Metaobject Data
  // 230282756467 무료버전 string service metaobject id (String Service #JI1KQT5W)
  // 240870293875 유료버전 string service metaobject id (String Service #TYGYQTK7)
  const stringServiceOptionQuery = `
    query {
      metaobject(id: "gid://shopify/Metaobject/240870293875") {
        id
        handle
        type
        fields {
          key
          value
        }
      }
    }
  `;

  // ✅ Query Recommend String Service Metaobject Data for Each Product
  const stringServiceRecommendQuery = `
    query {
      product(id: "gid://shopify/Product/${productId}") {
        metafields(identifiers: [
          {
            namespace: "custom",
            key: "string_service_recommend"
          }
        ]) {
          id
          value
          reference {
            ... on Metaobject {
              fields {
                key
                value
              }
            }
          }
        }
      }
    }
  `;

  const stringServiceOptionRes = await fetchGraphQL(stringServiceOptionQuery);
  const stringServiceOptionData = await stringServiceOptionRes.json();

  const stringServiceRecommendRes = await fetchGraphQL(stringServiceRecommendQuery);
  const stringServiceRecommendData = await stringServiceRecommendRes.json();

  // Populate all matching sections (main PDP + sticky popup)
  const createOption = (data, optionText, value) => {
    const targets = document.querySelectorAll(`[data-string-option-dropdown-select-value="${optionText}"]`);
    if (!targets.length) return;
    if (data) {
      let values;
      try { values = JSON.parse(data); } catch { return; }
      values.unshift('옵션을 선택해주세요');
      targets.forEach((target) => {
        const inStickyPopup = target.closest('[data-mobile-atc-popup]') || target.closest('[data-product-sticky-atc]');
        if (inStickyPopup && target.options[0] && target.options[0].value === '') {
          target.options[0].remove();
        }
        values.forEach((el) => {
          const optionElement = document.createElement('option');
          optionElement.value = el;
          optionElement.textContent = el;
          target.appendChild(optionElement);
          optionElement.style.display = 'none';
        });
      });
    } else {
      targets.forEach((target) => {
        const inStickyPopup = target.closest('[data-mobile-atc-popup]') || target.closest('[data-product-sticky-atc]');
        if (inStickyPopup && target.options[0] && target.options[0].value === '') {
          target.options[0].remove();
        }
        const optionElement = document.createElement('option');
        optionElement.value = value;
        optionElement.textContent = value;
        target.appendChild(optionElement);
        optionElement.style.display = 'none';
      });
    }
  };

  const createCustomStringOption = (data, optionText, value) => {
    const menuTargets = document.querySelectorAll(`[data-custom-string-option-dropdown-menu-value="${optionText}"]`);
    if (!menuTargets.length) return;
    if (data) {
      let values;
      try { values = JSON.parse(data); } catch { return; }
      values.unshift('옵션을 선택해주세요');
      menuTargets.forEach((menuEl) => {
        const inStickyPopup = menuEl.closest('[data-mobile-atc-popup]') || menuEl.closest('[data-product-sticky-atc]');
        const valuesToShow = inStickyPopup ? values.filter((el) => el !== '옵션을 선택해주세요') : values;
        valuesToShow.forEach((el) => {
          const liElement = document.createElement('li');
          liElement.classList.add('custom-string-option-dropdown-item');
          liElement.setAttribute('data-custom-string-option-dropdown-item', '');
          liElement.setAttribute('data-custom-string-option-dropdown-item-value', el);
          liElement.textContent = el;
          menuEl.appendChild(liElement);
        });
      });
    } else if (optionText === '스트링 모델') {
      menuTargets.forEach((menuEl) => {
        const inStickyPopup = menuEl.closest('[data-mobile-atc-popup]') || menuEl.closest('[data-product-sticky-atc]');
        if (inStickyPopup && value === '옵션을 선택해주세요') return;
        const liElement = document.createElement('li');
        liElement.classList.add('custom-string-option-dropdown-item');
        liElement.setAttribute('data-custom-string-option-dropdown-item', '');
        liElement.setAttribute('data-custom-string-option-dropdown-item-value', value);

        const colorSpan = document.createElement('span');
        colorSpan.setAttribute('data-string-color-value', value);
        colorSpan.classList.add('string-color');
        liElement.appendChild(colorSpan);

        const valueSpan = document.createElement('span');
        valueSpan.textContent = value;
        liElement.appendChild(valueSpan);

        menuEl.appendChild(liElement);
      });
    } else {
      menuTargets.forEach((menuEl) => {
        const inStickyPopup = menuEl.closest('[data-mobile-atc-popup]') || menuEl.closest('[data-product-sticky-atc]');
        if (inStickyPopup && value === '옵션을 선택해주세요') return;
        const liElement = document.createElement('li');
        liElement.classList.add('custom-string-option-dropdown-item');
        liElement.setAttribute('data-custom-string-option-dropdown-item', '');
        liElement.setAttribute('data-custom-string-option-dropdown-item-value', value);
        liElement.textContent = value;
        menuEl.appendChild(liElement);
      });
    }
  };

  const resetStringOption = async (scope) => {
    const root = scope && scope.querySelector ? scope : document;
    stringOptionLabels.forEach((label) => {
      root.querySelectorAll(`[data-string-option-dropdown-select-value="${label}"]`).forEach((selectEl) => {
        selectEl.selectedIndex = 0;
        selectEl.dispatchEvent(new Event('change'));
      });
    });

    showAllStencilOptions();

    root.querySelectorAll('[data-string-option-dropdown-select]').forEach((select) => {
      select.disabled = false;
    });
  };

  const updateButtonStates = ({
    cartEnabled = true,
    buyNowEnabled = true,
  } = {}, opts = {}) => {
    // Only update sticky when explicitly requested; PDP changes must not touch sticky (fixes first-time PDP change updating sticky)
    const updateStickyPopup = opts.updateStickyPopup === true;
    // Only update PDP when explicitly requested; when change is from sticky popup we must not touch PDP
    const updatePdpButtons = opts.updatePdpButtons === true;

    if (updatePdpButtons) {
      // PDP only: use main product variant selector (exclude sticky popup) so sticky variant change never affects PDP
      const allVariantSelects = document.querySelectorAll('[data-main-product-variant], [data-original-selector], select.original-selector[name="id"]');
      const variantSelector = Array.from(allVariantSelects).find(function (el) {
        return !el.closest('[data-product-sticky-atc]') && !el.closest('[data-mobile-atc-popup]');
      });
      if (!variantSelector) return;
      const selectedOption = variantSelector?.options[variantSelector?.selectedIndex];
      const inventoryQuantity = selectedOption ? parseInt(selectedOption.getAttribute('data-inventory') || '0') : 0;
      const isSoldOut = inventoryQuantity <= 0;

      // Orichi 에러 메시지만 체크 (Orichi가 모든 수량 제한을 처리함)
      const quantityError = document.querySelector('.orichi-quantity-textError');
      const hasQuantityError = quantityError &&
        quantityError.textContent.trim() !== '' &&
        getComputedStyle(quantityError).display !== 'none' &&
        getComputedStyle(quantityError).visibility !== 'hidden';

      console.log('[string-service-charge] hasQuantityError:', hasQuantityError, 'errorText:', quantityError?.textContent?.trim()?.substring(0, 30));

      // Cart button: when cartEnabled but quantity error exists, show disabled-state button
      if (buyCartBtnDisabled) {
        const showDisabledCartBtn = !cartEnabled || (cartEnabled && hasQuantityError);
        buyCartBtnDisabled.style.display = showDisabledCartBtn ? 'block' : 'none';
      }
      if (buyCartBtn) {
        if (isSoldOut) {
          buyCartBtn.style.display = 'none';
        } else if (cartEnabled && !hasQuantityError) {
          buyCartBtn.style.display = 'block';
        } else {
          buyCartBtn.style.display = 'none';
        }
      }

      // Sold out: hide both 구매하기 buttons; in stock: show main or disabled-state so one is always visible when options valid
      if (isSoldOut) {
        if (buyNowBtn) buyNowBtn.style.display = 'none';
        if (buyNowBtnDisabled) buyNowBtnDisabled.style.display = 'none';
        if (buyNowEmptyBtn) buyNowEmptyBtn.style.display = 'none';
      } else if (isCustomer) {
        if (buyNowBtn) {
          if (buyNowEnabled && !hasQuantityError) {
            buyNowBtn.style.display = 'block';
            if (buyNowBtnDisabled) buyNowBtnDisabled.style.display = 'none';
          } else {
            buyNowBtn.style.display = 'none';
            if (buyNowBtnDisabled) buyNowBtnDisabled.style.display = buyNowEnabled ? 'block' : 'none';
          }
        }
      } else {
        if (buyNowEmptyBtn) {
          if (buyNowEnabled && !hasQuantityError) {
            buyNowEmptyBtn.style.display = 'block';
            if (buyNowEmptyBtnDisabled) buyNowEmptyBtnDisabled.style.display = 'none';
          } else {
            buyNowEmptyBtn.style.display = 'none';
            if (buyNowEmptyBtnDisabled) buyNowEmptyBtnDisabled.style.display = buyNowEnabled ? 'block' : 'none';
          }
        }
      }
    }

    // data-sticky-atc-cart-button (inside popup): only update when change was inside sticky popup (not from PDP string dropdown)
    if (!updateStickyPopup) return;
    const stickyAtcContainer = document.querySelector('[data-product-sticky-atc]');
    if (stickyAtcContainer) {
      const stickyCartBtn = stickyAtcContainer.querySelector('[data-sticky-atc-cart-button]');
      const stickyCartBtnDisabled = stickyAtcContainer.querySelector('[data-sticky-atc-cart-button--disabled]');
      const stickyButtonsWrapper = stickyAtcContainer.querySelector('[data-sticky-atc-buttons-wrapper]');
      const stickyNotification = stickyAtcContainer.querySelector('[data-variant-unavailable-notification]');
      const stickyForm = stickyAtcContainer.querySelector('form');
      const stickyVariantSelect = stickyForm?.querySelector('select.original-selector, select[name="id"]');
      let stickyInventory = 0;
      if (stickyVariantSelect?.options?.length) {
        const opt = stickyVariantSelect.options[stickyVariantSelect.selectedIndex];
        if (opt) stickyInventory = parseInt(opt.getAttribute('data-inventory') || '0', 10) || 0;
      }
      const stickySoldOut = stickyInventory <= 0;
      if (stickySoldOut) {
        if (stickyButtonsWrapper) stickyButtonsWrapper.style.display = 'none';
        if (stickyCartBtn) {
          stickyCartBtn.classList.add('orichi-quantity-limited');
          stickyCartBtn.disabled = true;
        }
        if (stickyCartBtnDisabled) stickyCartBtnDisabled.classList.add('orichi-quantity-limited');
        if (stickyNotification) stickyNotification.style.display = 'block';
      } else {
        if (stickyButtonsWrapper) stickyButtonsWrapper.style.display = 'block';
        // Orichi 에러 메시지만 체크 (PDP의 에러 메시지 사용)
        const stickyQuantityError = document.querySelector('.orichi-quantity-textError');
        const stickyQuantityLimited = stickyQuantityError &&
          stickyQuantityError.textContent.trim() !== '' &&
          getComputedStyle(stickyQuantityError).display !== 'none' &&
          getComputedStyle(stickyQuantityError).visibility !== 'hidden';

        // 전달받은 cartEnabled를 그대로 사용 (호출자가 selectedOptions 기준으로 판단)
        let stickyCartEnabled = cartEnabled;

        console.log('[sticky updateButtonStates] stickyCartEnabled:', stickyCartEnabled, 'stickyQuantityLimited:', stickyQuantityLimited);

        if (stickyCartBtn) {
          if (!stickyCartEnabled) {
            console.log('[sticky] hiding button: stickyCartEnabled is false');
            stickyCartBtn.classList.add('orichi-quantity-limited');
            stickyCartBtn.disabled = true;
          } else if (stickyQuantityLimited) {
            console.log('[sticky] hiding button: stickyQuantityLimited is true');
            stickyCartBtn.classList.add('orichi-quantity-limited');
            stickyCartBtn.disabled = true;
          } else {
            console.log('[sticky] showing button: stickyCartEnabled and not stickyQuantityLimited');
            stickyCartBtn.classList.remove('orichi-quantity-limited');
            stickyCartBtn.disabled = false;
          }
        }
        if (stickyCartBtnDisabled) {
          const showDisabledStickyBtn = !stickyCartEnabled || (stickyCartEnabled && stickyQuantityLimited);
          console.log('[sticky] disabled button display:', showDisabledStickyBtn ? 'block' : 'none');
          if (showDisabledStickyBtn) {
            stickyCartBtnDisabled.classList.remove('orichi-quantity-limited');
            stickyCartBtnDisabled.style.display = 'block';
          } else {
            stickyCartBtnDisabled.classList.add('orichi-quantity-limited');
            stickyCartBtnDisabled.style.display = '';
          }
        }
        if (stickyNotification) stickyNotification.style.display = 'none';
      }
    }
  };

  updateButtonStates({ cartEnabled: false, buyNowEnabled: false }, { updatePdpButtons: true, updateStickyPopup: true });

  // syncStickyButtonStates는 renderState()로 대체됨

  // 장바구니 업데이트 시 재고 수량 재계산 및 버튼 상태 업데이트
  const refreshInventoryFromCart = async () => {
    try {
      const cartResponse = await fetch('/cart.js', { cache: 'no-store' });
      const cartData = await cartResponse.json();

      // 현재 상품의 variant별 장바구니 수량 집계
      const cartQuantityByVariant = {};
      cartData.items.forEach(item => {
        if (item.product_id == productId) {
          cartQuantityByVariant[item.variant_id] = (cartQuantityByVariant[item.variant_id] || 0) + item.quantity;
        }
      });

      // 모든 variant select 옵션의 data-inventory 업데이트
      const allVariantSelects = document.querySelectorAll('select.original-selector[name="id"], select[data-original-selector]');
      allVariantSelects.forEach(select => {
        Array.from(select.options).forEach(option => {
          const variantId = option.value;
          const originalInventory = parseInt(option.getAttribute('data-original-inventory') || option.getAttribute('data-inventory') || '0', 10);

          // 최초 원본 재고 저장 (한 번만)
          if (!option.hasAttribute('data-original-inventory')) {
            option.setAttribute('data-original-inventory', originalInventory);
          }

          const cartQty = cartQuantityByVariant[variantId] || 0;
          const availableInventory = Math.max(0, originalInventory - cartQty);
          option.setAttribute('data-inventory', availableInventory);
        });
      });

      // Orichi 앱의 수량 에러 메시지 업데이트를 위해 quantity input 이벤트 트리거
      const quantityInput = document.querySelector('input[name="quantity"]');
      if (quantityInput) {
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
      }

      // Orichi가 에러 메시지 업데이트할 시간을 준 후 버튼 상태 업데이트
      setTimeout(() => {
        const enabled = getButtonEnabled();
        console.log('[refreshInventoryFromCart] Updating button states after Orichi update');
        updateButtonStates({ cartEnabled: enabled, buyNowEnabled: enabled }, { updatePdpButtons: true, updateStickyPopup: true });
      }, 150);
    } catch (error) {
      console.error('Failed to refresh inventory from cart:', error);
    }
  };

  // cart:updated 이벤트 리스닝 (jQuery)
  if (window.jQuery) {
    window.jQuery(document).on('cart:updated', () => {
      setTimeout(refreshInventoryFromCart, 300);
    });
  }

  // theme:cartchanged 이벤트 리스닝 (장바구니 수량 변경/삭제 시)
  document.addEventListener('theme:cartchanged', () => {
    setTimeout(refreshInventoryFromCart, 300);
  });

  // 장바구니 drawer/modal 닫힐 때도 체크
  document.addEventListener('cart:close', () => {
    setTimeout(refreshInventoryFromCart, 300);
  });

  // PDP 수량 input 변경 시 버튼 상태 업데이트
  const quantityInputForObserve = document.querySelector('input[name="quantity"]');
  if (quantityInputForObserve) {
    const updateButtonsOnQuantityChange = () => {
      // Orichi가 에러 메시지를 업데이트할 시간을 준 후 버튼 상태 업데이트
      // (MutationObserver가 Orichi 에러 변경을 감지하면 자동으로 업데이트됨)
      setTimeout(() => {
        const enabled = getButtonEnabled();
        console.log('[updateButtonsOnQuantityChange] Updating button states');
        updateButtonStates({ cartEnabled: enabled, buyNowEnabled: enabled }, { updatePdpButtons: true, updateStickyPopup: true });
      }, 100);
    };

    // 디바운스 처리
    let quantityChangeTimeout;
    const debouncedUpdate = () => {
      clearTimeout(quantityChangeTimeout);
      quantityChangeTimeout = setTimeout(updateButtonsOnQuantityChange, 200);
    };

    quantityInputForObserve.addEventListener('change', debouncedUpdate);
    quantityInputForObserve.addEventListener('input', debouncedUpdate);

    // Orichi 앱이 +/- 버튼으로 수량 변경 시를 위한 MutationObserver
    const quantityObserver = new MutationObserver(debouncedUpdate);
    quantityObserver.observe(quantityInputForObserve, { attributes: true, attributeFilter: ['value'] });
  }

  const stringServiceAlert = () => {
    if (stringServiceSelector.value === stringOptions[0]) {
      alert('스트링 옵션을 먼저 선택해주세요');
    }
  }

  const disabledButtons = [
    buyNowEmptyBtnDisabled,
    buyCartBtnDisabled,
    buyNowBtnDisabled
  ];

  disabledButtons.forEach(button => {
    button?.addEventListener('click', (e) => {
      e.preventDefault();
      stringServiceAlert();
    });
  });

  // Orichi 에러 메시지 변경 감시 (MutationObserver)
  const observeOrichiError = () => {
    const quantityError = document.querySelector('.orichi-quantity-textError');
    if (!quantityError) {
      // 에러 요소가 아직 없으면 잠시 후 다시 시도
      setTimeout(observeOrichiError, 500);
      return;
    }

    const updateButtonsFromOrichi = () => {
      const enabled = getButtonEnabled();
      console.log('[Orichi Observer] Error changed, updating buttons');
      updateButtonStates({ cartEnabled: enabled, buyNowEnabled: enabled }, { updatePdpButtons: true, updateStickyPopup: true });
    };

    // 에러 메시지 요소의 변경 감시
    const observer = new MutationObserver(() => {
      updateButtonsFromOrichi();
    });

    observer.observe(quantityError, {
      childList: true,
      characterData: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // 부모 요소도 감시 (visibility 변경 등)
    const parent = quantityError.parentElement;
    if (parent) {
      const parentObserver = new MutationObserver(() => {
        updateButtonsFromOrichi();
      });
      parentObserver.observe(parent, {
        childList: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    console.log('[Orichi Observer] Started watching .orichi-quantity-textError');
  };

  // DOM 로드 후 Observer 시작
  setTimeout(observeOrichiError, 100);

  // service charges (string price) encryption (backend shared key)
  const secret = "string_service_charge_price_key";
  const salt = "string_service_charge_price_salt";

  const encryptPrice = async (price) => {
    const enc = new TextEncoder();
  
    const baseKey = await crypto.subtle.importKey(
      "raw",
      enc.encode(secret),
      "PBKDF2",
      false,
      ["deriveKey"]
    );
  
    const aesKey = await crypto.subtle.deriveKey(
      {
        name: "PBKDF2",
        salt: enc.encode(salt),
        iterations: 100000,
        hash: "SHA-256",
      },
      baseKey,
      { name: "AES-GCM", length: 256 },
      true,
      ["encrypt"]
    );
  
    const iv = crypto.getRandomValues(new Uint8Array(12));
  
    const encrypted = await crypto.subtle.encrypt(
      { name: "AES-GCM", iv },
      aesKey,
      enc.encode(price)
    );
  
    const cipher = btoa(String.fromCharCode(...new Uint8Array(encrypted)));
    const ivBase64 = btoa(String.fromCharCode(...iv));
  
    return { cipher, iv: ivBase64 };
  };

  // ✅ String Option Section UI
  // 1. custom dropdown menu – support both main PDP and sticky ATC popup via event delegation
  const customDropdownsStringService = document.querySelectorAll('[data-custom-string-option-dropdown-menu]');

  function getStringDropdownContainer(el) {
    const container = el?.closest('.dropdown-container');
    return container?.querySelector('[data-string-dropdown-select]') ? container : null;
  }

  /** In sticky popup only: sync class "selected" on string option dropdown menu items to match the select value. */
  function syncStringOptionDropdownSelected(selectEl) {
    if (!selectEl || (!selectEl.closest('[data-mobile-atc-popup]') && !selectEl.closest('[data-product-sticky-atc]'))) return;
    const optionText = selectEl.getAttribute('data-string-option-dropdown-select-value');
    const section = selectEl.closest('.string-option-section');
    const menu = section?.querySelector(`[data-custom-string-option-dropdown-menu-value="${optionText}"]`);
    if (!menu) return;
    const currentValue = selectEl.value || '';
    menu.querySelectorAll('[data-custom-string-option-dropdown-item]').forEach((li) => {
      const val = li.getAttribute('data-custom-string-option-dropdown-item-value');
      if (val === currentValue) li.classList.add('selected');
      else li.classList.remove('selected');
    });
  }

  /** Sync which option shows as active in the dropdown menu (ul > li) and update value display. */
  function syncMainDropdownDisplayAndActive(container) {
    if (!container) return;
    const selectEl = container.querySelector('[data-string-dropdown-select]');
    const menu = container.querySelector('[data-custom-dropdown-menu]');
    if (!selectEl || !menu) return;
    const currentValue = selectEl.value || selectEl.getAttribute('data-string-dropdown-select-value') || '';
    const items = menu.querySelectorAll('[data-custom-dropdown-item]');
    items.forEach((li) => {
      const val = li.getAttribute('data-custom-dropdown-item-value');
      if (val === currentValue) li.classList.add('active');
      else li.classList.remove('active');
    });
    const prettySelect = selectEl.closest('.pretty-select');
    const valueDisplay =
      selectEl.nextElementSibling?.querySelector('.value') ||
      (prettySelect ? prettySelect.querySelector('.text .value') : null);
    if (valueDisplay) {
      const option = selectEl.options[selectEl.selectedIndex];
      const raw = option ? option.textContent : currentValue;
      const inStickyPopup = container.closest('[data-mobile-atc-popup]') || container.closest('[data-product-sticky-atc]');
      const isStringOptionDropdown = container.closest('.string-option-section');
      valueDisplay.textContent = inStickyPopup && isStringOptionDropdown ? truncateTo40Bytes(raw) : raw;
    }
  }

  // Click on pretty-select (or dropdown container if select not wrapped) → set ul to display block
  document.addEventListener('click', (e) => {
    // Don't treat clicks on menu options as "open/close trigger" – let item handler deal with them
    if (e.target.closest('[data-custom-dropdown-menu]')) return;
    // Clicking the string guide link should navigate, not open the dropdown
    if (e.target.closest('a.dropdown-string-guide[href]')) return;

    let container = null;
    const prettySelect = e.target.closest('.pretty-select');
    if (prettySelect) {
      container = getStringDropdownContainer(prettySelect);
    }
    if (!container) {
      const clickedContainer = e.target.closest('.dropdown-container');
      if (clickedContainer?.querySelector('[data-string-dropdown-select]')) {
        container = clickedContainer;
      }
    }
    if (!container) return;

    const selectEl = container.querySelector('[data-string-dropdown-select]');
    const menu = container.querySelector('[data-custom-dropdown-menu]');
    if (!selectEl || !menu) return;

    e.preventDefault();
    e.stopPropagation();
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
  });

  document.addEventListener('touchstart', (e) => {
    if (e.target.closest('[data-custom-dropdown-menu]')) return;
    if (e.target.closest('a.dropdown-string-guide[href]')) return;

    let container = null;
    const prettySelect = e.target.closest('.pretty-select');
    if (prettySelect) container = getStringDropdownContainer(prettySelect);
    if (!container) {
      const touched = e.target.closest('.dropdown-container');
      if (touched?.querySelector('[data-string-dropdown-select]')) container = touched;
    }
    if (!container) return;

    const menu = container.querySelector('[data-custom-dropdown-menu]');
    if (!menu) return;

    e.preventDefault();
    menu.style.display = menu.style.display === 'block' ? 'none' : 'block';
  }, { passive: false });

  // Click on dropdown option (li) → set select value, close menu, fire change (→ runMainStringDropdownChange → renderState)
  document.addEventListener('click', (e) => {
    const item = e.target.closest('[data-custom-dropdown-item]');
    if (!item) return;

    try {
      const container = getStringDropdownContainer(item);
      if (!container) return;

      const selectEl = container.querySelector('[data-string-dropdown-select]');
      const menu = container.querySelector('[data-custom-dropdown-menu]');
      if (!selectEl || !menu) return;

      const selectedValue = item.getAttribute('data-custom-dropdown-item-value');
      if (!selectedValue) return;

      selectEl.value = selectedValue;
      menu.style.display = 'none';

      // 모바일 스크롤: 옵션 섹션이 보이면 스크롤
      const stickyAtc = container.closest('[data-product-sticky-atc]');
      if (stickyAtc) {
        const opts = selectEl.getAttribute('data-string-options');
        const optionsHere = opts ? JSON.parse(opts) : stringOptions;
        const showSection = selectedValue !== optionsHere[0] && selectedValue !== optionsHere[3];
        if (showSection && window.matchMedia('(max-width: 767px)').matches) {
          const stickySection = stickyAtc.querySelector('[data-string-option-section]');
          const popupBody = stickyAtc.querySelector('[data-mobile-atc-popup] .as-productStickyAtc__atcPopupBody');
          if (popupBody && stickySection) {
            requestAnimationFrame(() => {
              const bodyRect = popupBody.getBoundingClientRect();
              const sectionRect = stickySection.getBoundingClientRect();
              const top = popupBody.scrollTop + (sectionRect.top - bodyRect.top) + 25;
              popupBody.scrollTo({ top: top, behavior: 'smooth' });
            });
          }
        }
      }

      // change 이벤트 → runMainStringDropdownChange → renderState()
      selectEl.dispatchEvent(new Event('change', { bubbles: true }));
    } catch (err) {
      console.warn('String dropdown item click:', err);
    }
  });

  // Open/close string-option dropdowns – scope to same .string-option-section (main PDP or sticky popup)
  document.addEventListener('click', (e) => {
    const prettySelect = e.target.closest('.string-option-section .pretty-select');
    if (!prettySelect || prettySelect.classList.contains('is-disabled')) return;

    const section = prettySelect.closest('.string-option-section');
    const selectEl = prettySelect.querySelector('select');
    if (!section || !selectEl) return;

    const selectValue = selectEl.getAttribute('data-string-option-dropdown-select-value');
    const targetDropdown = section.querySelector(`[data-custom-string-option-dropdown-menu-value="${selectValue}"]`);
    if (!targetDropdown) return;

    e.preventDefault();
    e.stopPropagation();

    const wasOpen = targetDropdown.style.display === 'block';
    document.querySelectorAll('[data-custom-string-option-dropdown-menu]').forEach((menu) => {
      menu.style.display = 'none';
    });
    if (!wasOpen) {
      syncStringOptionDropdownSelected(selectEl);
      targetDropdown.style.display = 'block';
    }
  });

  document.querySelectorAll('[data-string-option-dropdown-select]').forEach((select) => {
    const optionText = select.getAttribute('data-string-option-dropdown-select-value');
    const section = select.closest('.string-option-section');
    const menuOption = section ? section.querySelector(`[data-custom-string-option-dropdown-menu-value="${optionText}"]`) : null;
    if (!menuOption) return;

    select.addEventListener('touchstart', (e) => {
      e.preventDefault();
      document.querySelectorAll('[data-custom-string-option-dropdown-menu]').forEach((menu) => {
        if (menu !== menuOption) menu.style.display = 'none';
      });
      const opening = menuOption.style.display !== 'block';
      if (opening) syncStringOptionDropdownSelected(select);
      menuOption.style.display = menuOption.style.display === 'block' ? 'none' : 'block';
    }, { passive: false });

    select.addEventListener('click', () => {
      document.querySelectorAll('[data-custom-string-option-dropdown-menu]').forEach((menu) => {
        if (menu !== menuOption) menu.style.display = 'none';
      });
      const opening = menuOption.style.display !== 'block';
      if (opening) syncStringOptionDropdownSelected(select);
      menuOption.style.display = menuOption.style.display === 'block' ? 'none' : 'block';
    });
  });


  // 2. Create Dropdown String Options
  const stringOptionsData = stringServiceOptionData?.data?.metaobject?.fields;
  if (stringOptionsData) {
    // Process sync fields immediately, collect async work for string_model
    let stringModelPromise = null;
    for (const field of stringOptionsData) {
      if (field.key === 'string_model') {
        stringModelPromise = (async () => {
          const values = JSON.parse(field.value);
          const productPromises = values.map(async value => {
            const productRes = await fetchGraphQL(productQuery(value));
            const productData = await productRes.json();
            return productData.data.product;
          });
          const products = await Promise.all(productPromises);
          products.unshift({ title: '옵션을 선택해주세요' });
          products?.forEach((product) => {
            const price = Math.floor(product.variants?.edges[0].node.price.amount);
            const priceString = price >= 0 ? `${product.title} + (${price.toLocaleString()}₩)` : `${product.title}`;
            createCustomStringOption(null, '스트링 모델', priceString);
            createOption(null, '스트링 모델', priceString);
          });
        })();
      }
      if (field.key === 'tension_mains') {
        createOption(field.value, '텐션 세로(메인)');
        createCustomStringOption(field.value, '텐션 세로(메인)');
      }
      if (field.key === 'tension_crosses') {
        createOption(field.value, '텐션 가로(크로스)');
        createCustomStringOption(field.value, '텐션 가로(크로스)');
      }
      if (field.key === 'stencil') {
        createOption(field.value, '스텐실');
        createCustomStringOption(field.value, '스텐실');
      }
      if (field.key === 'overgrip') {
        const overgripSelects = document.querySelectorAll('[data-string-option-dropdown-select-value="오버그립(사은품)"]');
        if (field.value === 'true') {
          const overgripOptionValues = ['옵션을 선택해주세요', '미선택', '무료로 제공됩니다. (+ 0원)'];
          overgripSelects.forEach((el) => { el.style.display = 'block'; });
          overgripOptionValues.forEach(value => {
            createCustomStringOption(null, '오버그립(사은품)', value);
            createOption(null, '오버그립(사은품)', value);
          });
        } else {
          overgripSelects.forEach((el) => { el.style.display = 'none'; });
        }
      }
    }
    // Wait for string_model async options to be fully created before user can interact
    if (stringModelPromise) await stringModelPromise;
  }

  const setStringModelColor = (select, stringModel) => {
    const valueSpan = select.parentElement.querySelector('.text > .value'); 
    if (valueSpan) {
      valueSpan.innerHTML = '';

      if (stringModel !== '옵션을 선택해주세요') {
        const colorSpan = document.createElement('span');
        colorSpan.setAttribute('data-string-color-value', stringModel);
        colorSpan.classList.add('string-color');
        valueSpan.appendChild(colorSpan);

        const textSpan = document.createElement('span');
        textSpan.className = 'string-option-section__dropdown-value-text';
        const inStickyPopup = select.closest('[data-mobile-atc-popup]') || select.closest('[data-product-sticky-atc]');
        const isStringOptionDropdown = select.closest('.string-option-section');
        textSpan.textContent = inStickyPopup && isStringOptionDropdown ? truncateTo40Bytes(stringModel) : stringModel;
        valueSpan.appendChild(textSpan);
      } else {
        valueSpan.textContent = stringModel;
      }
    }
  }

  // after all string options are created – item click: update the select in the same section as the menu
  const customStringOptionDropdownMenus = document.querySelectorAll('[data-custom-string-option-dropdown-menu]');
  customStringOptionDropdownMenus.forEach((menu) => {
    menu.addEventListener('click', (e) => {
      const item = e.target.closest('[data-custom-string-option-dropdown-item]');
      if (!item) return;

      const selectedValue = item.getAttribute('data-custom-string-option-dropdown-item-value');
      const optionText = menu.getAttribute('data-custom-string-option-dropdown-menu-value');
      const section = menu.closest('.string-option-section');
      const select = section ? section.querySelector(`[data-string-option-dropdown-select-value="${optionText}"]`) : document.querySelector(`[data-string-option-dropdown-select-value="${optionText}"]`);
      if (!select) return;

      select.value = selectedValue;
      select.dispatchEvent(new Event('change'));

      if (optionText === '스트링 모델') {
        setStringModelColor(select, selectedValue);
      }

      syncStringOptionDropdownSelected(select);
      menu.style.display = 'none';
    });
  });

  document.body.addEventListener('click', (e) => {
    const isDropdownMenu = e.target.closest('[data-custom-string-option-dropdown-menu]');
    const isSelect = e.target.closest('[data-string-option-dropdown-select]');
    const isStringOptionMenu = e.target.closest('[data-custom-dropdown-menu]');
    const isStringOptionSelect = e.target.closest('[data-string-dropdown-select]');

    if (!isDropdownMenu && !isSelect) {
      customStringOptionDropdownMenus.forEach(menu => {
        menu.style.display = 'none';
      })
    }

    if (!isStringOptionMenu && !isStringOptionSelect) {
      document.querySelectorAll('[data-string-dropdown-select]').forEach(select => {
        const container = select.closest('.dropdown-container');
        const menu = container?.querySelector('[data-custom-dropdown-menu]');
        if (menu) menu.style.display = 'none';
      });
    }
  });

  // 3. Handle String Option Section UI when main string dropdown changes (PDP or sticky popup)
  const runMainStringDropdownChange = async (selectEl, selectedValue) => {
    if (!selectEl) return;

    // selectedOptions 업데이트 — renderState()가 모든 UI를 파생
    const needsServiceId = selectedValue && selectedValue !== stringOptions[0] && selectedValue !== stringOptions[3];
    selectedOptions = {
      service_id: needsServiceId ? generateServiceId() : '',
      string_option: selectedValue,
      string_model: '',
      tension_mains: '',
      tension_crosses: '',
      stencil_value: '',
      overgrip_yn: selectedValue === stringOptions[1] ? 'Y' : '', // 직접 선택 시 오버그립 자동 Y
      service_charge: 'N',
    };
    encryptedServiceChargePrice = '';

    if (selectedValue === stringOptions[2]) {
      // 추천 스트링: 먼저 로딩 상태 렌더, API 호출 후 다시 렌더
      renderState();
      await loadRecommendedString();
    }

    renderState();
  };

  // Main PDP: direct listener so reset/recommend/disable always runs
  if (stringServiceSelector) {
    stringServiceSelector.addEventListener('change', async (e) => {
      await runMainStringDropdownChange(e.target, e.target.value);
    });
  }
  // Sticky popup: delegated listener for any other [data-string-dropdown-select] (sticky’s dropdown)
  document.addEventListener('change', async (e) => {
    if (e.target === stringServiceSelector) return;
    if (!e.target.matches || !e.target.matches('[data-string-dropdown-select]')) return;
    await runMainStringDropdownChange(e.target, e.target.value);
  }, true);

  // 4. Update String Option & Data when String Option Dropdown Select Value Changed (main PDP or sticky popup)
  // selectedOptions만 업데이트하고 renderState()가 모든 UI를 파생
  stringOptionSelects.forEach(select => {
    select.addEventListener('change', async (e) => {
      const selectedValue = e.target.value;
      const optionType = select.getAttribute('data-string-option-dropdown-select-value');
      const emptyOption = '옵션을 선택해주세요';

      switch (optionType) {
        case '스트링 모델':
          selectedOptions.string_model = selectedValue === emptyOption ? '' : selectedValue;
          // 스텐실 규칙: 모델에 따라 stencil_value 강제 변경
          if (selectedValue !== emptyOption) {
            const modelName = selectedValue.split(' + ')[0];
            const rules = stringModelStencilRules[modelName];
            if (rules && rules.availableStencilOptions[0] === '스텐실 작업 불가') {
              selectedOptions.stencil_value = '스텐실 작업 불가';
            } else if (rules && rules.defaultStencil === '옵션을 선택해주세요') {
              selectedOptions.stencil_value = '';
            }
            // 가격 암호화
            const priceMatch = selectedValue.match(/\(([^)]+)\)/);
            if (priceMatch) {
              const price = parseInt(priceMatch[1].replace(/[^0-9]/g, ''));
              const { cipher, iv } = await encryptPrice(price);
              encryptedServiceChargePrice = JSON.stringify({ cipher, iv });
            }
          } else {
            encryptedServiceChargePrice = '';
          }
          break;
        case '텐션 세로(메인)':
          selectedOptions.tension_mains = selectedValue === emptyOption ? '' : selectedValue;
          break;
        case '텐션 가로(크로스)':
          selectedOptions.tension_crosses = selectedValue === emptyOption ? '' : selectedValue;
          break;
        case '스텐실':
          selectedOptions.stencil_value = selectedValue.includes('미선택') ? 'null' : selectedValue === emptyOption ? '' : selectedValue;
          break;
        case '오버그립(사은품)':
          selectedOptions.overgrip_yn = selectedValue === '무료로 제공됩니다. (+ 0원)' ? 'Y' : 'N';
          break;
      }

      // service_id 갱신
      const option = selectedOptions.string_option;
      if (option === stringOptions[3] || option === stringOptions[0]) {
        selectedOptions.service_id = '';
      } else if (!selectedOptions.service_id) {
        selectedOptions.service_id = generateServiceId();
      }

      renderState();
    })
  });

  /** Update visible .value in pretty-select so programmatic select.value shows in UI (main PDP and sticky popup). */
  const updatePrettySelectDisplay = (selectEl, text) => {
    if (!selectEl) return;
    const valueEl = selectEl.nextElementSibling?.querySelector('.value') || selectEl.closest('.pretty-select')?.querySelector('.text .value');
    if (valueEl) {
      const raw = text != null ? text : selectEl.value;
      const inStickyPopup = selectEl.closest('[data-mobile-atc-popup]') || selectEl.closest('[data-product-sticky-atc]');
      const isStringOptionDropdown = selectEl.closest('.string-option-section');
      valueEl.textContent = inStickyPopup && isStringOptionDropdown ? truncateTo40Bytes(raw) : raw;
    }
  };

  // 추천 스트링: selectedOptions + encryptedServiceChargePrice만 업데이트 (DOM 조작은 renderState에 위임)
  const loadRecommendedString = async () => {
    const recommendStringData = stringServiceRecommendData?.data?.product?.metafields[0]?.reference?.fields;
    if (!recommendStringData) return;

    for (const data of recommendStringData) {
      if (data.key === 'string_model') {
        const stringRes = await fetchGraphQL(productQuery(data.value));
        const stringData = await stringRes.json();
        const product = stringData?.data?.product;
        if (!product) continue;
        const stringModel = product.title;
        const priceNode = product.variants?.edges?.[0]?.node?.price;
        const stringPrice = priceNode ? Math.floor(Number(priceNode.amount)) : 0;
        selectedOptions.string_model = stringPrice >= 0 ? `${stringModel} + (${stringPrice.toLocaleString()}₩)` : stringModel;

        const { cipher, iv } = await encryptPrice(stringPrice);
        encryptedServiceChargePrice = JSON.stringify({ cipher, iv });
      }
      if (data.key === 'tension_mains') selectedOptions.tension_mains = data.value;
      if (data.key === 'tension_crosses') selectedOptions.tension_crosses = data.value;
      if (data.key === 'stencil') selectedOptions.stencil_value = data.value.includes('미선택') ? 'null' : data.value;
      if (data.key === 'overgrip') selectedOptions.overgrip_yn = data.value === 'false' ? 'N' : 'Y';
    }

    selectedOptions.service_id = generateServiceId();
  };

  // ✅ String Guide Popup Function
  const initStringGuidePopup = () => {
    const stringGuideElement = document.querySelector('[data-string-guide-text]');
    const stringGuidePopup = document.querySelector('[data-string-guide-popup]');
    const stringGuideOverlay = document.querySelector('[data-string-guide-overlay]');
    const stringGuidePopupClose = document.querySelector('[data-string-guide-popup-close]');
  
    const openStringGuide = () => {
      stringGuidePopup.classList.add('active');
      stringGuideOverlay.classList.add('active');
    };
  
    const closeStringGuide = () => {
      stringGuidePopup.classList.remove('active');
      stringGuideOverlay.classList.remove('active');
    };
  
    stringGuideElement?.addEventListener('click', () => {
      openStringGuide();
    });
  
    stringGuideOverlay?.addEventListener('click', () => {
      closeStringGuide();
    });
  
    stringGuidePopupClose?.addEventListener('click', () => {
      closeStringGuide();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStringGuidePopup);
  } else {
    initStringGuidePopup();
  }

  window.addEventListener('beforeunload', () => {
    selectedOptions = {
      service_id: '', string_option: stringOptions[0], string_model: '',
      tension_mains: '', tension_crosses: '', stencil_value: '',
      overgrip_yn: '', service_charge: 'N',
    };
    encryptedServiceChargePrice = '';
    renderState();
  });

  const preserveButtonStatesOnVariantChange = () => {
    if (!selectedOptions.string_option || selectedOptions.string_option === stringOptions[0]) return;
    requestAnimationFrame(() => renderButtons());
  };
  if (window.jQuery) {
    window.jQuery(window).on('cc-variant-updated', function() {
      setTimeout(() => preserveButtonStatesOnVariantChange(), 100);
    });
    const productForm = document.querySelector('[data-product-id]')?.closest('form');
    if (productForm) {
      window.jQuery(productForm).on('variantChanged', function() {
        setTimeout(() => preserveButtonStatesOnVariantChange(), 100);
      });
    }
  }
  const mainVariantSelects = document.querySelectorAll('[data-main-product-variant], [data-original-selector]');
  const mainVariantSelector = Array.from(mainVariantSelects).find(function (el) {
    return !el.closest('[data-product-sticky-atc]') && !el.closest('[data-mobile-atc-popup]');
  });
  if (mainVariantSelector) {
    mainVariantSelector.addEventListener('change', () => {
      setTimeout(() => {
        preserveButtonStatesOnVariantChange();
      }, 100);
    });
  }

  // Initial sync of main string dropdown display and active option (PDP + sticky)
  document.querySelectorAll('.dropdown-container').forEach((container) => {
    if (container.querySelector('[data-string-dropdown-select]')) syncMainDropdownDisplayAndActive(container);
  });

  // Validate _string_data on main PDP form submit
  // Use capture phase on document to run BEFORE theme.js jQuery handler on the form.
  // theme.js registers its own submit handler that does $.post (AJAX add to cart),
  // so we must intercept and stop propagation when validation fails.
  const productForm = stringDataInput?.closest('form');
  if (productForm) {
    document.addEventListener('submit', (e) => {
      if (e.target !== productForm) return;
      if (!validateStringData()) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event from reaching theme.js handler on the form
        alert('스트링 옵션을 모두 선택해주세요.');
        return;
      }
      // Ensure all forms have canonical state before theme.js serializes
      renderState();
    }, true); // capture phase
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initStringServiceCharge);
} else {
  initStringServiceCharge();
}